import { HttpClientModule, HttpClientXsrfModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { MatButtonModule } from "@angular/material/button";
import { MatNativeDateModule, MAT_DATE_LOCALE } from "@angular/material/core";
import { MatDividerModule } from "@angular/material/divider";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatToolbarModule } from "@angular/material/toolbar";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule } from "@angular/router";
import { DialogModule, FlexBladeModule, HttpModule, LoadingOverlayModule, SharedCommonModule, StorageModule } from "@shared";
import { AppComponent } from "./AppComponent";
import { AppRedirectGuard } from "./AppRedirectGuard";
import { AppRedirectGuardOptions } from "./AppRedirectGuardOptions";

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
		HttpClientModule,
		HttpClientXsrfModule.withOptions({
			cookieName: "KicktheTyres.Identity.Xsrf"
		}),
        FlexLayoutModule,
        MatButtonModule,
        MatDividerModule,
        MatFormFieldModule,
        MatSelectModule,
        MatIconModule,
        MatListModule,
        MatMenuModule,
        MatNativeDateModule,
		MatProgressSpinnerModule,
        MatSidenavModule,
		MatSlideToggleModule,
        MatSnackBarModule,
        MatToolbarModule,
        RouterModule.forRoot([{
            path: "login",
            loadChildren: () => import("./Login/LoginModule").then(m => m.LoginModule),
            canLoad: [AppRedirectGuard],
            data: { guardOptions: new AppRedirectGuardOptions(false) }
        }, {
			path: "passphrase-recovery",
			loadChildren: () => import("./PassphraseRecovery/PassphraseRecoveryModule").then(m => m.PassphraseRecoveryModule),
            canLoad: [AppRedirectGuard],
            data: { guardOptions: new AppRedirectGuardOptions(false) }
        }, {
            path: "consent",
            loadChildren: () => import("./Consent/ConsentModule").then(m => m.ConsentModule),
            canLoad: [AppRedirectGuard],
            data: { guardOptions: new AppRedirectGuardOptions(true) }
        }, {
            path: "invitation",
            loadChildren: () => import("./Invitation/InvitationModule").then(m => m.InvitationModule)
        }, {
            path: "profile",
            loadChildren: () => import("./UserProfiles/UserProfileModule").then(m => m.UserProfileModule),
            canLoad: [AppRedirectGuard],
            data: { guardOptions: new AppRedirectGuardOptions(true) }
        }, {
            path: "logout",
            loadChildren: () => import("./Logout/LogoutModule").then(m => m.LogoutModule),
            canLoad: [AppRedirectGuard],
            data: { guardOptions: new AppRedirectGuardOptions(true) }
        }, {
            path: "**",
            redirectTo: "/login"
        }], {
            paramsInheritanceStrategy: "always",
            relativeLinkResolution: "legacy"
        }),
		DialogModule,
		FlexBladeModule,
		HttpModule,
		LoadingOverlayModule,
		SharedCommonModule,
		StorageModule,
    ],
    providers: [
        AppRedirectGuard,
        { provide: MAT_DATE_LOCALE, useValue: "en-GB" }
    ],
    bootstrap: [
        AppComponent
    ]
})
export class AppModule { }
